import { PresenceStatus, PresenceStatusInGameData, PresenceStatusType } from "../../src/server/socket/types";
import Link from "next/link";
import PresenceIndicator from "../global/presenceindicator";
import { useTheme } from "../global/theme";
import React, { useState } from "react";
import { getApproximateTimeString } from "@/src/util/relativetime";

type Props = {
    status: PresenceStatus;
    lastOnlineAt?: Date | null;
};

export default function UserProfileDialogPresence(
    {
        lastOnlineAt,
        status,
    }: Props,
): JSX.Element {
    const { theme } = useTheme();
    const [now] = useState<number>(() => Date.now());

    let text: string | JSX.Element;

    if (status.type === PresenceStatusType.Offline) {
        if (lastOnlineAt) {
            const lastOnlineDate = new Date(lastOnlineAt);
            const relativeTime = getApproximateTimeString(lastOnlineDate.getTime(), now);
            text = `Offline (last online ${relativeTime} ago)`;
        } else {
            text = 'Offline';
        }
    } else if (status.type === PresenceStatusType.Online) {
        text = 'Online';
    } else if (status.type === PresenceStatusType.InGame) {
        const inGameData = status.data as PresenceStatusInGameData;
        const gameName = inGameData.gameName ?? inGameData.gameId.toString();
        text = <Link href={`/game/play?id=${inGameData.gameId}`}>
            Playing {gameName}
        </ Link>;
    }

    const textElement = <React.Fragment>
        &nbsp;
        {text}
    </React.Fragment>

    return <PresenceIndicator
        text={textElement}
        theme={theme}
        type={status.type}
    />;
}
